// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iOrZBML\\+QMgdVBAvnvMoKw\\=\\={margin-left:-1rem}", "",{"version":3,"sources":["webpack://./components/buttons/Button/styles.module.scss"],"names":[],"mappings":"AAAA,6BACE,iBAAA","sourcesContent":[".alignWithoutPadding {\n  margin-left: -1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alignWithoutPadding": "iOrZBML+QMgdVBAvnvMoKw=="
};
export default ___CSS_LOADER_EXPORT___;
